/**
 * CurrencyToggle — ₡ CRC / $ USD para alternar la moneda de visualización de
 * montos ya calculados (no cambia el idioma de la UI). Mismo lenguaje visual
 * (píldora con borde y fondo tintado por color) que los botones de acción
 * vecinos (Estado de Cuenta, Multa/Sanción, Exportar Excel), en vez del
 * switch segmentado plano de antes.
 */
export default function CurrencyToggle({ value, onChange, title }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {["CRC", "USD"].map((m) => {
        const active = value === m;
        return (
          <button key={m} type="button" onClick={() => onChange(m)}
            title={title}
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              padding: "8px 14px", borderRadius: 8,
              background: active ? "rgba(249,115,22,0.15)" : "transparent",
              border: `1px solid ${active ? "rgba(249,115,22,0.4)" : "var(--border-card)"}`,
              color: active ? "#f97316" : "var(--text-muted)",
              fontWeight: 600, fontSize: "0.83rem", cursor: "pointer",
              transition: "all 0.15s",
            }}>
            {m === "CRC" ? "₡ CRC" : "$ USD"}
          </button>
        );
      })}
    </div>
  );
}
